<template>
  <div class="header-text">
    <img src="~@/assets/images/about/history-text.png" />
  </div>
  <img class="history-circle" src="~@/assets/images/about/history-circle.png" />
  <img class="line-bg" src="~@/assets/images/about/history-timeline.png" />
  <div class="history-container" @touchstart="touchStart">
    <swiper
      class="history-swiper"
      :modules="modules"
      :autoplay="{
        delay: 3000,
        disableOnInteraction: true,
      }"
      :navigation="{
        nextEl: '.right-btn',
        prevEl: '.left-btn',
      }"
      :loop="true"
      style="height: 100%; width: 100%"
      :slidesPerView="1"
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="item in list" :key="item.year">
        <div class="top-container">
          <div class="left-btn-block"></div>
          <div class="main-container">
            <div class="image-main">
              <img :class="['img' + item.year]" :src="item.img_url" />
            </div>
            <div class="content swiper-no-swiping" v-html="item.content"></div>
          </div>
          <div class="right-btn-block"></div>
        </div>
        <div class="history-timeline">
          <div class="left-year">{{ item.left_year }}</div>
          <div class="center-image">
            <img :src="item.center_img" />
            <div>{{ item.center_year }}</div>
          </div>
          <div class="right-year">
            <div class="year">{{ item.right_year }}</div>
            <div class="expect" v-if="item.isExpect">敬请期待</div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="left-btn">
      <img src="~@/assets/images/about/left-arrow.png" />
    </div>
    <div class="right-btn">
      <img src="~@/assets/images/about/right-arrow.png" />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";
const modules = [Navigation, Pagination, Scrollbar, A11y, Autoplay];
const currentIndex = ref(0);
const onSlideChange = (e) => {
  console.log(e);
  currentIndex.value = e.realIndex;
};
const swiperRef = ref({});
const onSwiper = (swiper) => {
  swiperRef.value = swiper;
};

const touchStart = () => {
  swiperRef.value.autoplay.stop();
};

import img2015 from "@/assets/images/about/history-2015-img.png";
import imgCenter2015 from "@/assets/images/about/history-2015-timeline.png";

import img2016 from "@/assets/images/about/history-2016-img.png";
import imgCenter2016 from "@/assets/images/about/history-2016-timeline.png";

import img2017 from "@/assets/images/about/history-2017-img.png";
import imgCenter2017 from "@/assets/images/about/history-2017-timeline.png";

import img2018 from "@/assets/images/about/history-2018-img.png";
import imgCenter2018 from "@/assets/images/about/history-2018-timeline.png";

import img2019 from "@/assets/images/about/history-2019-img.png";
import imgCenter2019 from "@/assets/images/about/history-2019-timeline.png";

import img2020 from "@/assets/images/about/history-2020-img.png";
import imgCenter2020 from "@/assets/images/about/history-2020-timeline.png";

import img2021 from "@/assets/images/about/history-2021-img.png";
import imgCenter2021 from "@/assets/images/about/history-2021-timeline.png";

import img2022 from "@/assets/images/about/history-2022-img.png";
import imgCenter2022 from "@/assets/images/about/history-2022-timeline.png";

import img2023 from "@/assets/images/about/history-2023-img.png";
import imgCenter2023 from "@/assets/images/about/history-2023-timeline.png";

import img2024 from "@/assets/images/about/history-2024-img.png";
import imgCenter2024 from "@/assets/images/about/history-2024-timeline.png";

const list = reactive([
  {
    year: 2015,
    content: `
      <p>广州乐牛软件科技有限公司成立，并立下“打造面向用户的游戏精品、立足用户需求”的产品理念，以手游的研发与发行作为核心发展领域；</p>
      <p>乐牛团队规模成形，开启手游研发和发行的创业之路，潜心打造一流的手游产品；</p>
      <p>推出首款“轻回合”代理产品《魔域英雄》，正式踏入手游发行市场。</p>
    `,
    img_url: img2015,

    left_year: 2014,
    center_year: 2015,
    center_img: imgCenter2015,
    right_year: 2016,
    isExpect: false,
  },
  {
    year: 2016,
    content: `
      <p>手游研发、发行两条业务线并驾齐驱，研发和发行的核心竞争力迅速成长；</p>
      <p>首款自研产品《猎魔传说》上线并且得到市场的认可，研发实力得到了市场验证；</p>
      <p>独代产品《仙灵奇缘》上线，月流水破千万，发行能力初步显现。</p>
    `,
    img_url: img2016,

    left_year: 2015,
    center_year: 2016,
    center_img: imgCenter2016,
    right_year: 2017,
    isExpect: false,
  },
  {
    year: 2017,
    content: `
      <p>公司业务线全面布局加速，平台事业部成立，为产品发行保驾护航，团队规模和业绩成数倍速度增长，逐步完成创业期积累；</p>
      <p>自研产品《猎魔传说》持续爆发，荣获安智“最具潜质游戏”奖、智汇推“品牌营销”奖；</p>
      <p>代理产品《昆仑墟》，月流水创新高；独代产品《宿命契约》顺利上线，创下年流水过亿的佳绩，公司发行实力日趋成熟；</p>
      <p>公司荣获“爱奇艺2017年度最佳合作伙伴” 奖；</p>
      <p>CEO周皓黎荣获“硬核联盟年度新锐影响力人物” 奖。</p>
    `,
    img_url: img2017,

    left_year: 2016,
    center_year: 2017,
    center_img: imgCenter2017,
    right_year: 2018,
    isExpect: false,
  },
  {
    year: 2018,
    content: `
      <p>公司自研团队持续发力，发行全闭环业务链逐步完善，业绩突飞猛进；</p>
      <p>自研产品《猎魔传说》再度荣获三星商店2018“最具影响力游戏” 奖；</p>
      <p>自研产品《重生之明月传说》和《暗黑觉醒》正式上线，成绩斐然；</p>
      <p>独代产品《宿命契约》荣获第四届硬核联盟黑石奖“硬核年度最受欢迎MMO游戏” 奖，代理发行《刀剑物语》也取得优异的成绩；</p>
      <p>公司荣获“腾讯应用宝年度合作伙伴”奖、“OPPO优秀合作伙伴”奖、“金茶奖最佳移动游戏发行商”奖；</p>
      <p>CEO周皓黎荣获第四届硬核联盟黑石奖“硬核年度新锐影响力人物”奖。</p>
    `,
    img_url: img2018,

    left_year: 2017,
    center_year: 2018,
    center_img: imgCenter2018,
    right_year: 2019,
    isExpect: false,
  },
  {
    year: 2019,
    content: `
      <p>研发及发行团队成熟稳健，并不断开拓新的产品品类及业务领域，紧随市场趋势突破业务；</p>
      <p>自研产品《驯龙物语》正式上线，获得市场高度关注和热烈反响，取得优异的成绩，并荣获第五届硬核联盟黑石奖“硬核年度最受欢迎二次元游戏”奖；</p>
      <p>自研产品《暗黑觉醒》荣获三星应用商店2019“最具人气游戏” 奖；</p>
      <p>公司荣获三星应用商店“2019最佳合作伙伴”奖、第五届硬核联盟黑石奖“硬核年度最受关注游戏公司”奖、“金茶奖2019年最佳移动游戏发行商”奖；</p>
      <p>CEO周皓黎荣获第五届硬核联盟黑石奖“硬核年度行业领军人物”奖。</p>
    `,
    img_url: img2019,

    left_year: 2018,
    center_year: 2019,
    center_img: imgCenter2019,
    right_year: 2020,
    isExpect: false,
  },
  {
    year: 2020,
    content: `
      <p>自研产品《九灵神域》正式上线，全渠道大力推广，备受关注；</p>
      <p>CEO周皓黎荣获第六届硬核联盟黑石奖“硬核年度行业领军人物”奖。</p>
      <p>公司荣获“金钻榜最具成长性企业”、“腾讯向阳奖2020年卓越贡献广告主”奖；</p>
    `,
    img_url: img2020,

    left_year: 2019,
    center_year: 2020,
    center_img: imgCenter2020,
    right_year: 2021,
    isExpect: false,
  },
  {
    year: 2021,
    content: `
      <p>在深耕国内市场的同时逐步启动海外发行业务，打造全球业务链；</p>
      <p>公司荣获金钻榜“2021最具成长性企业”奖、“2021年度优秀网络游戏企业”奖、博鳌论坛“2021年度（行业）领军企业”奖、“2021广州最具成长性文化企业20佳”；</p>
      <p>公司荣获OPPO开发者大会“最具潜力合作伙伴”奖、华为应用市场“年度跃动星耀”奖、巨量引擎2021引擎奖“年度新锐大奖”、腾讯广告“向阳奖”品效杰出广告主奖；</p>
      <p>公司荣获广州市游戏行业协会2021年度“优秀企业奖”、“锐意进取奖”、“热心公益奖”、“疫情防控奉献奖”、“广州市游戏行业网络生态治理优秀企业奖”；</p>
      <p>CEO周皓黎荣获第七届硬核联盟黑石奖“硬核年度行业领军人物”。</p>
    `,
    img_url: img2021,

    left_year: 2020,
    center_year: 2021,
    center_img: imgCenter2021,
    right_year: 2022,
    isExpect: false,
  },
  {
    year: 2022,
    content: `
      <p>继续加快海外发行的步伐，坚定全方位的发展战略，致力提升产品品质和线上运营能力；</p>
      <p>公司当选广州市游戏行业协会副会长单位；</p>
      <p>公司荣获2022广州互联网企业风云榜“广州互联网企业20强”、亚洲经济大会“2022年度（行业）最具潜力企业”、金钻榜“2022最具成长性企业”、广东省游戏产业协会“2022年度社会公益奖”；</p>
      <p>CEO周皓黎荣获第六届博鳌企业论坛暨亚洲经济大会“2022年度（行业）创新人物”。</p>
      `,
    img_url: img2022,

    left_year: 2021,
    center_year: 2022,
    center_img: imgCenter2022,
    right_year: 2023,
    isExpect: false,
  },
  {
    year: 2023,
    content: `
      <p>自研产品《神火大陆》 全平台公测开启；</p>
      <p>公司成功入选2023-2024年度国家文化出口重点企业；</p>
      <p>公司旗下产品《九灵神域》荣获2023年vivo开发者大会“年度最佳角色扮演游戏”奖、华为开发者大会2023（HDC.Together）“最佳仙侠联动游戏”奖、《神火大陆》荣获2023 OPPO开发者大会（ODC23）“年度新游”奖及“年度营销表现”奖、2023年vivo开发者大会“年度最佳新游”奖；</p>
      <p>公司荣获2023（第七届）中国品牌博鳌峰会“2023年度（行业）标志品牌”奖、2023（第六届）中国经济大会“2023中国（行业）创新100强”奖、华为开发者大会2023（HDC.Together）“创新联运合作伙伴”奖、2023vivo开发者大会“年度最佳合作伙伴”、“营销年度最佳游戏公司”奖、2023 OPPO开发者大会（ODC23）“年度潜力合作伙伴”奖；</p>
      <p>CEO周皓黎荣获“广州女性创新创业先锋”称号，同时获聘为广州市女性创新创业导师、2023（第七届）中国品牌博鳌峰会“2023年度品牌人物·卓越贡献”奖、2023（第六届）中国经济大会“2023年度最具成长力女性领导者”奖、2023中国百杰女性创业论坛“2023中国杰出女企业家”称号。</p>
    `,
    img_url: img2023,

    left_year: 2022,
    center_year: 2023,
    center_img: imgCenter2023,
    right_year: 2024,
    isExpect: false,
  },
  {
    year: 2024,
    content:
      "公司持续推进手游精品化进程，扩展业务进程，入局H5游戏赛道，自研重磅产品《山海与妖灵》全平台首发！",
    img_url: img2024,

    left_year: 2023,
    center_year: 2024,
    center_img: imgCenter2024,
    right_year: 2025,
    isExpect: true,
  },
]);
</script>
<style lang="scss">
.history-container .history-swiper .top-container .content {
  p {
    font-size: 2.963rem;
    font-family: "SourceHanSansCN", "Microsoft YaHei", "Arial Narrow", Arial,
      sans-serif;
    color: #1e232e;
    margin-bottom: 1rem;
  }
}
</style>
<style lang="scss" scoped>
.header-text {
  position: absolute;
  top: 13.6111rem;
  left: 0;
  right: 0;
  text-align: center;

  img {
    width: 91.2963rem;
    height: 4.537rem;
  }
}
.history-circle {
  position: absolute;
  left: 0;
  top: 22.5rem;
  width: 100rem;
  height: 118.8889rem;
}
.history-container {
  position: absolute;
  top: 22.037rem;
  left: 0;
  width: 100%;
  // height: 79.6296rem;

  .history-swiper {
    overflow: visible;
    width: 100%;
    position: relative;
    .top-container {
      display: flex;
      justify-content: center;
      align-items: center;

      .left-btn-block,
      .right-btn-block {
        width: 11.1111rem;
        height: 8.4259rem;
        flex-shrink: 0;
      }

      .main-container {
        flex: 1;
        width: 1px;
        .image-main {
          width: 100%;
          height: 67.037rem;
          opacity: 1;
          transition: all 0.6s;
          display: flex;
          justify-content: center;
          align-items: flex-end;

          .img2015 {
            width: 77.5926rem;
            height: 50rem;
          }
          .img2016 {
            width: 77.5926rem;
            height: 65.463rem;
          }
          .img2017 {
            width: 77.5926rem;
            height: 76.8519rem;
          }
          .img2018 {
            width: 77.5926rem;
            height: 57.6852rem;
          }
          .img2019 {
            width: 77.5926rem;
            height: 58.7037rem;
          }
          .img2020 {
            width: 77.5926rem;
            height: 68.4259rem;
          }
          .img2021 {
            width: 77.5926rem;
            height: 56.7593rem;
          }
          .img2022 {
            width: 77.5926rem;
            height: 65.2778rem;
          }
          .img2023 {
            width: 77.5926rem;
            height: 61.9444rem;
          }
          .img2024 {
            width: 77.5926rem;
            height: 63.0556rem;
          }
        }
        .content {
          font-size: 2.963rem;
          font-family: "SourceHanSansCN", "Microsoft YaHei", "Arial Narrow",
            Arial, sans-serif;
          color: #1e232e;
          margin-top: 3rem;
          height: 16.5852rem;
          overflow-y: auto;
        }
      }
    }
  }
}
.history-timeline {
  position: absolute;
  left: 0;
  top: 87.5rem;
  z-index: 3;
  width: 100rem;
  height: 18.6111rem;
  .left-year {
    position: absolute;
    left: 5.7407rem;
    top: 3.7037rem;
    z-index: 3;
    width: 20.6481rem;
    height: 6.2963rem;
    text-align: center;
    line-height: 6.2963rem;
    // font-size: 8.037rem;
    font-size: 8.5185rem;
    font-weight: 700;
    color: #2b6392;
  }
  .center-image {
    position: absolute;
    left: 0;
    right: 0;
    z-index: 3;
    margin: auto;
    width: 17.8704rem;
    height: 100%;
    text-align: center;
    img {
      width: 13.4259rem;
      height: 13.4259rem;
    }
    div {
      width: 100%;
      margin-top: 1rem;
      color: #2b6392;
      font-size: 3.5185rem;
      font-weight: 700;
      font-family: "SourceHanSansCN", "Microsoft YaHei", "Arial Narrow", Arial;
    }
  }
  .right-year {
    position: absolute;
    right: 5.7407rem;
    top: 3.7037rem;
    z-index: 3;
    width: 20.6481rem;
    text-align: center;
    .year {
      height: 6.2963rem;
      line-height: 6.2963rem;
      // font-size: 8.037rem;
      font-size: 8.5185rem;
      font-weight: 700;
      color: #2b6392;
    }
    .expect {
      font-size: 2.5926rem;
      color: #8ca0ac;
      font-family: "SourceHanSansCN", "Microsoft YaHei", "Arial Narrow", Arial;
    }
  }
}

.line-bg {
  position: absolute;
  left: 0;
  // top: 5.9259rem;
  top: 115.2rem;
  width: 100%;
  height: 2.4074rem;
  z-index: 1;
}
.left-btn,
.right-btn {
  width: 11.1111rem;
  height: 8.4259rem;
  text-align: center;
  position: absolute;
  top: 37.8704rem;
  z-index: 2;
  img {
    width: 4.7222rem;
    height: 100%;
  }
}
.left-btn {
  left: 0;
}
.right-btn {
  right: 0;
}
</style>